import CashQueryForm from "./CashQueryForm";

export default CashQueryForm;
